// extracted by mini-css-extract-plugin
module.exports = {"container":"ChangesModale_container__3UfIJ","preview":"ChangesModale_preview__6htvI","changes":"ChangesModale_changes__1nVfo","change":"ChangesModale_change__30i0N"};